import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "service-list-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ServiceList = _resolveComponent("ServiceList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ServiceList, {
      class: "service-list-page-list",
      list: _ctx.services,
      onOnClick: _ctx.selectService
    }, null, 8, ["list", "onOnClick"])
  ]))
}